import React, { FC, useEffect } from 'react';
import { useParams } from "react-router-dom";
import { useFormik } from "formik";
import { useDispatchEx, useSelectorEx } from "../../hooks/redux";
import Select from "../../components/atoms/Select/Select";
import { getOrderStatus } from "../../helpers/functions";
import PreloaderContent from "../../components/atoms/PreloaderContent/PreloaderContent";
import { asyncGetOrderAction, asyncUpdateOrderAction } from "../../redux/slices/orders/ordersAction";
import Chat from "../../components/molecules/Chat/Chat";
import RectButton from "../../components/atoms/RectButton/RectButton";
import InputGradient from "../../components/molecules/InputGradient/InputGradient";

const OrderPage: FC = () => {
    const { orderID } = useParams();

    const { order, isLoading } = useSelectorEx(state => state.orders);
    const dispatch = useDispatchEx();

    const { handleSubmit, setFieldValue, values } = useFormik({
        initialValues: {
            status: order?.status ?? 1,
            money_from: order?.money_from ?? 0,
            money_to: order?.money_to ?? 0,
            rate: order?.rate ?? 0,
        },
        enableReinitialize: true,
        validationSchema: null,
        onSubmit: (value) => formHandle(value),
    });

    const formHandle = (formValues: any) => {
        dispatch(asyncUpdateOrderAction({
            id: Number(orderID),
            status: Number(formValues.status),
            money_from: Number(formValues.money_from),
            money_to: Number(formValues.money_to),
            rate: Number(formValues.rate),
        }));
    };

    useEffect(() => {
        dispatch(asyncGetOrderAction(Number(orderID)));
    }, [dispatch, orderID]);

    // Обработчики для автоматического пересчета
    const onChangeMoneyFrom = (e: React.ChangeEvent<HTMLInputElement>) => {
        const val = e.target.value;
        setFieldValue('money_from', val);
        if (values.rate && Number(values.rate) !== 0) {
            setFieldValue('money_to', (Number(val) / Number(values.rate)).toFixed(4));
        }
    };

    const onChangeRate = (e: React.ChangeEvent<HTMLInputElement>) => {
        const val = e.target.value;
        setFieldValue('rate', val);
        if (val && Number(val) !== 0) {
            setFieldValue('money_to', (Number(values.money_from) / Number(val)).toFixed(4));
        }
    };

    const onChangeMoneyTo = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFieldValue('money_to', e.target.value); // Полностью ручное управление
    };

    const tg_user = order?.tg_user ? JSON.parse(order.tg_user) : "";

    return (
        <div className={'main-admin__content'}>
            <div className="main-admin__header">
                <h1 style={{ color: "#ffffff", marginBottom: "20px" }}>Заявка № {orderID}</h1>
            </div>

            <div className="main-admin__form">
                <div className="main-admin__form-block">
                    <Chat />
                </div>

                <div className="main-admin__form-block main-admin__form-group">
                    {!isLoading ? (
                        <>
                            <div className="main-admin__form-block">
                                <div className="main-admin__card">
                                    <div className="main-admin__card-title">Информация</div>

                                    <div className="main-admin__card-content">

                                        <div className="main-admin__card-item">
                                            <span>Телефон:</span>
                                            <span>{order?.phone}</span>
                                        </div>

                                        <div className="main-admin__card-item">
                                            <span>Логин ТГ:</span>
                                            <span>{order?.tg_login || "-"}</span>
                                        </div>

                                        <div className="main-admin__card-item">
                                            <span>Email:</span>
                                            <span>{order?.email || "-"}</span>
                                        </div>

                                        <div className="main-admin__card-item">
                                            <span>Telegram user:</span>
                                            <span>
                                                {tg_user
                                                    ? `ID: ${tg_user.id} Name: ${tg_user?.first_name} ${tg_user?.last_name} UserName: ${tg_user?.username}`
                                                    : "None"}
                                            </span>
                                        </div>

                                        <div className="main-admin__card-item">
                                            <span>Страна:</span>
                                            <span>{order?.country}</span>
                                        </div>

                                        {/* Вернули статичное отображение информации */}
                                        <div className="main-admin__card-item">
                                            <span>Сумма отправки:</span>
                                            <span>{order?.money_from} RUB ({order?.type_from})</span>
                                        </div>

                                        <div className="main-admin__card-item">
                                            <span>Курс:</span>
                                            <span>{order?.rate} RUB = 1.00 {order?.type_to}</span>
                                        </div>

                                        <div className="main-admin__card-item">
                                            <span>Сумма получения:</span>
                                            <span>{order?.money_to} {order?.type_to}</span>
                                        </div>

                                        <div className="main-admin__card-item">
                                            <span>Город наличных:</span>
                                            <span>{order?.cash_city || "-"}</span>
                                        </div>

                                        <div className="main-admin__card-item">
                                            <span>Способ получения:</span>
                                            <span>{order?.receive_method || "-"}</span>
                                        </div>

                                        <div className="main-admin__card-item">
                                            <span>IP:</span>
                                            <span>{order?.ip}</span>
                                        </div>

                                        <div className="main-admin__card-item">
                                            <span>utm_source:</span>
                                            <span>{order?.utm_source}</span>
                                        </div>

                                        <div className="main-admin__card-item">
                                            <span>utm_medium:</span>
                                            <span>{order?.utm_medium}</span>
                                        </div>

                                        <div className="main-admin__card-item">
                                            <span>utm_campaign:</span>
                                            <span>{order?.utm_campaign}</span>
                                        </div>

                                        <div className="main-admin__card-item">
                                            <span>utm_content:</span>
                                            <span>{order?.utm_content}</span>
                                        </div>

                                        <div className="main-admin__card-item">
                                            <span>utm_term:</span>
                                            <span>{order?.utm_term}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="main-admin__form-block">
                                <div className="main-admin__input" style={{ marginBottom: '20px' }}>
                                    <InputGradient
                                        name={'money_from'}
                                        type={'text'}
                                        placeholder={`Сумма отправки (${order?.type_from})`}
                                        value={String(values.money_from)}
                                        onChange={onChangeMoneyFrom}
                                    />
                                </div>

                                <div className="main-admin__input" style={{ marginBottom: '20px' }}>
                                    <InputGradient
                                        name={'rate'}
                                        type={'text'}
                                        placeholder={`Курс (RUB = 1 ${order?.type_to})`}
                                        value={String(values.rate)}
                                        onChange={onChangeRate}
                                    />
                                </div>

                                <div className="main-admin__input" style={{ marginBottom: '20px' }}>
                                    <InputGradient
                                        name={'money_to'}
                                        type={'text'}
                                        placeholder={`Сумма получения (${order?.type_to})`}
                                        value={String(values.money_to)}
                                        onChange={onChangeMoneyTo}
                                    />
                                </div>

                                <div className="main-admin__input" style={{ marginBottom: '20px' }}>
                                    <Select
                                        defaultValue={order?.status?.toString()}
                                        onChange={(value) => {
                                            setFieldValue('status', Number(value));
                                        }}
                                        placeholder={'Статус'}
                                        items={[
                                            { value: '1', name: getOrderStatus(1).name },
                                            { value: '2', name: getOrderStatus(2).name },
                                            { value: '3', name: getOrderStatus(3).name },
                                            { value: '4', name: getOrderStatus(4).name },
                                            { value: '5', name: getOrderStatus(5).name }
                                        ]}
                                    />
                                </div>

                                <div className="main-admin__input">
                                    <RectButton
                                        onClick={() => handleSubmit()}
                                        type={'button'}
                                        className={'btn-rect-gradient-long'}
                                        name={'Обновить'}
                                    />
                                </div>
                            </div>
                        </>
                    ) : (
                        <PreloaderContent />
                    )}
                </div>
            </div>
        </div>
    );
};

export default OrderPage;